import React from 'react'
import styled from 'styled-components'
import Notice from '../Common/Notice'
import { __ } from '../../services/translate'

export default (props) => (
  <Notice>
    <Container>
      <i className="fa fa-calendar fa-2x"/>
      <TextWrapper>
        <strong>{__('Nasledujíci státní svátek')}</strong>
        <div>{props.children}</div>
      </TextWrapper>
    </Container>
  </Notice>
)

const Container = styled.div`
  display: flex;
`

const TextWrapper = styled.div`
  margin-left: 1rem;
`
